// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1898 ? "28efd8eb" : chunkId) + "." + {"1898":"56ac49d9ebed682d","7931":"38f508dcc0478ebe","9059":"c225d447cbe73726"}[chunkId] + ".js";
};